import type { LucideIcon } from 'lucide-react';
import { Card } from '@shared/components/ui';

interface ComingSoonPanelProps {
  description: string;
  icon: LucideIcon;
  notice: string;
  title: string;
}

export default function ComingSoonPanel({
  description,
  icon: Icon,
  notice,
  title,
}: ComingSoonPanelProps) {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="app-page-title">{title}</h1>
        <p className="mt-1 text-text-muted-light dark:text-text-muted-dark">{description}</p>
      </div>
      <Card className="flex min-h-64 flex-col items-center justify-center gap-4 p-8 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-surface-2-light text-brand-600 dark:bg-surface-2-dark dark:text-brand-400">
          <Icon size={28} aria-hidden="true" />
        </span>
        <p className="max-w-lg text-sm leading-6 text-text-muted-light dark:text-text-muted-dark">
          {notice}
        </p>
      </Card>
    </div>
  );
}
